import { Component, Input } from '@angular/core';

/**
 * This component is used to display visual feedback to a user to validate if the data enter is correct or not.
 */
@Component({
	selector: 'cc-input-feedback',
	templateUrl: './input-feedback.component.html',
	styleUrls: ['./input-feedback.component.css']
})
export class InputFeedbackComponent {

// #region [ Fields ]

	/** Indicates if validation UI element should be shown at all. */
	@Input() public ShowValidation: boolean = false;

	/** The function pointer to the validation function - likely in the component class. */
	@Input() public ValidationFunction: Function = null;

	/** The message to associate with the negative validator. */
	@Input() public ErrorMessage: string = "";

// #region [ Properties ]

	/**
	 * Used to indicate if the negative validation UI should be displayed.
	 */
	public get ShowNegativeValidator(): boolean {
		if (this.ValidationFunction != null)
			return this.ShowValidation && !this.ValidationFunction();
		else
			return false;
	}

	/**
	 * Used to indicate if the positive validation UI should be displayed.
	 */
	public get ShowPositiveValidator(): boolean {
		if (this.ValidationFunction != null)
			return this.ShowValidation && this.ValidationFunction();
		else
			return false;
	}

}